import React from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import { InviteStatus, PlaydateInvite } from "../../../gql/types";
import ActionButton from "../../button/ActionButton";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import ParticipantSummaryRow from "../ParticipantSummaryRow";
import { ProfileRowPlacementType } from "../../profile/ProfileDetailRow";
import UnderlineButton from "../../button/UnderlineButton";

type PlaydateInviteCanceledViewProps = {
    invite: PlaydateInvite;
    onBack: () => void;
    onCreateNewInvite: () => void;
    baseZIndex?: number;
};

const PlaydateInviteCanceledView: React.FC<PlaydateInviteCanceledViewProps> = ({
    invite,
    onBack,
    onCreateNewInvite,
    baseZIndex,
}) => {
    const infoText = invite.expired && invite.status !== InviteStatus.Abandoned
        ? "Oops, this invite has expired."
        : "Oops, this invite has been canceled.";

    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Playdate Invite Details"
            infoText={infoText}
            topIcon="sad"
            useSectionDivider={true}
        >
            <div className={styles.contentBuffer} />
            <div className={styles.sectionHeader}>Host:</div>
            <ParticipantSummaryRow
                participant={invite.organizer}
                placement={ProfileRowPlacementType.STANDALONE}
                isReadOnly={true}
            />

            <div className={styles.sectionHeader}>Message from Host:</div>
            <div className={`${styles.notes} ${styles.readOnly}`}>
                {invite.cancellationMessage || (
                    <em>No cancellation message provided.</em>
                )}
            </div>

            <div className={styles.buttonBuffer} />
            <div className={styles.buttonContainer}>
                <ActionButton
                    onClick={onCreateNewInvite}
                    isLongText={true}
                >
                    Create a New Playdate Invite
                </ActionButton>
                <UnderlineButton onClick={onBack}>
                    Back
                </UnderlineButton>
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteCanceledView;
